export const verifyEmailErrorInformation: { [id: string]: string } = {
  "Takeda error | verifyUserEmail":
    "Email Verification Failed. Invalid or expired token",
  "Takeda error | raiseRequestForTakedaVerification":
    "There seems to some problem with lead generation. Please try again later.",
  tokenExpired: "Email Verification Failed. Expired token",
  invalidToken: "Email Verification Failed. Invalid token",
};
